import { ReactElement, useCallback, useRef, useState } from 'react';

import { ctxPopup } from '@/contexts/PopupContext';
import Loader from '@/components/common/Loader';
import { LoaderProps } from '@/types';

export default function Popups({ children }: { children: ReactElement }) {
  const [popupLoader, setPopupLoader] = useState<ReactElement | undefined>(undefined);
  const [drawerMenuOpen, setDrawerMenuOpen] = useState<boolean>(false);
  const counter = useRef(0);

  // TODO ne lehessen secondary-t masikkal felulirni ?
  // TODO lehessen tobb notification is ??

  const showLoader = useCallback((type?: LoaderProps) => {
    if (counter.current === 0) {
      setPopupLoader(<Loader type={type} />);
    }
    counter.current++;
  }, []);

  const hideLoader = useCallback(() => {
    counter.current--;
    if (counter.current === 0) {
      setPopupLoader(undefined);
    }
  }, []);

  return (
    <ctxPopup.Provider
      value={{
        setPopupLoader,
        showLoader,
        hideLoader,
        setDrawerMenuOpen,
        drawerMenuOpen,
      }}
    >
      {popupLoader}
      {children}
    </ctxPopup.Provider>
  );
}
